import enumFactory from "@util/enumFactory";

export default enumFactory.createEnum({

    TO_AUDIT: {
        code: 1,
        title: '待审核'
    },
    AUDIT_SUCCESS: {
        code: 2,
        title: '审核通过'
    },
    AUDIT_FAILURE: {
        code: 3,
        title: '审核不通过'
    },
    FINISHED: {
        code: 4,
        title: '已完成'
    },
    BEFORE_REFUND: {
        code: 5,
        title: '待退款'
    },
    CLOSED: {
        code: 6,
        title: '已关闭'
    }


});
